import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { RootSharedModule } from './acore/sharedModules';
import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { UtilityModule } from './acore/utility';
import { ServiceModule } from './acore/services';
import { GuardModules } from './acore/guards';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AGModule } from './acore/components/ag-component';
import { ComponentModule } from './acore/components';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    routing,
    BrowserModule,
    FormsModule,
    RootSharedModule,
    AGModule,
    UtilityModule,
    ServiceModule,
    GuardModules,
    ComponentModule,
    BrowserAnimationsModule,
  ],
  providers: [
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
